import { render, staticRenderFns } from "./cargoCascader.vue?vue&type=template&id=1fb16139&scoped=true&"
import script from "./cargoCascader.vue?vue&type=script&lang=js&"
export * from "./cargoCascader.vue?vue&type=script&lang=js&"
import style0 from "./cargoCascader.vue?vue&type=style&index=0&id=1fb16139&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb16139",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb16139')) {
      api.createRecord('1fb16139', component.options)
    } else {
      api.reload('1fb16139', component.options)
    }
    module.hot.accept("./cargoCascader.vue?vue&type=template&id=1fb16139&scoped=true&", function () {
      api.rerender('1fb16139', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoCascader.vue"
export default component.exports